<template>
  <svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512.001 512.001" :height="`${height}px` || '24px'" :width="`${width}px` || '24px'" :class="`fill-current  text-${color}`">
    <g>
      <g>
        <path
          d="M502.001,392.626c5.522,0,10-4.478,10-10v-17.487c-0.001-26.691-15.375-49.846-37.724-61.118
			c11.627-9.844,19.028-24.532,19.028-40.924v-12.464c0-29.567-24.055-53.622-53.622-53.622s-53.622,24.055-53.622,53.622v12.464
			c0,14.249,5.597,27.207,14.694,36.82c-17.581,3.922-34.205,11.406-49.055,22.239l-90.552,66.06
			c-1.872,1.366-3.588,2.901-5.148,4.568c-1.56-1.667-3.277-3.202-5.148-4.568l-90.552-66.06
			c-14.85-10.833-31.474-18.317-49.055-22.239c9.097-9.613,14.695-22.571,14.695-36.82v-12.464
			c0-29.567-24.055-53.622-53.622-53.622s-53.622,24.055-53.622,53.622v12.464c0,16.392,7.401,31.08,19.028,40.924
			C15.374,315.293,0,338.448,0,365.14v136.839c0,5.522,4.478,10,10,10h124.635c5.522,0,10-4.478,10-10v-91.823l65.429,39.45
			c11.547,6.962,25.448,7.159,37.188,0.53c3.316-1.873,6.238-4.187,8.748-6.829c2.51,2.643,5.432,4.957,8.748,6.829
			c5.713,3.227,11.938,4.836,18.153,4.836c6.558,0,13.107-1.792,19.034-5.366l65.43-39.45v91.823c0,5.522,4.478,10,10,10H502
			c5.522,0,10-4.478,10-10v-36.13c0-5.522-4.478-10-10-10c-5.522,0-10,4.478-10,10v26.13H387.365v-92.285
			c0-0.518-0.052-1.023-0.127-1.52l10.87-6.554c4.73-2.852,6.252-8.997,3.4-13.727c-2.853-4.73-9.001-6.255-13.727-3.4
			l-96.173,57.986c-5.287,3.188-11.652,3.278-17.025,0.242c-5.374-3.035-8.583-8.532-8.583-14.705
			c0-5.375,2.593-10.476,6.936-13.644l90.552-66.06c19.365-14.128,42.271-21.595,66.243-21.595h13.847
			c26.7,0,48.423,21.722,48.423,48.422v17.487C492.001,388.148,496.479,392.626,502.001,392.626z M38.695,250.633
			c0-18.539,15.083-33.622,33.622-33.622s33.622,15.083,33.622,33.622v12.464c0,18.539-15.083,33.622-33.622,33.622
			s-33.622-15.083-33.622-33.622V250.633z M237.417,432.721c-5.376,3.035-11.74,2.944-17.026-0.242l-96.172-57.986
			c-4.729-2.854-10.876-1.329-13.727,3.4c-2.852,4.729-1.33,10.875,3.4,13.727l10.858,6.547c-0.076,0.498-0.116,1.008-0.116,1.527
			v92.285H20V365.14c0-26.7,21.723-48.422,48.423-48.422H82.27c23.972,0,46.878,7.467,66.243,21.595l90.552,66.06
			c4.343,3.168,6.936,8.269,6.936,13.644C246,424.189,242.791,429.686,237.417,432.721z M473.305,263.097
			c0,18.539-15.083,33.622-33.622,33.622s-33.622-15.083-33.622-33.622v-12.464c0-18.539,15.083-33.622,33.622-33.622
			s33.622,15.083,33.622,33.622V263.097z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M509.069,415.94c-1.859-1.859-4.439-2.92-7.069-2.92s-5.21,1.061-7.07,2.92c-1.86,1.87-2.93,4.44-2.93,7.07
			c0,2.64,1.069,5.21,2.93,7.08c1.86,1.86,4.44,2.93,7.07,2.93s5.21-1.069,7.069-2.93c1.86-1.87,2.931-4.44,2.931-7.08
			C512,420.38,510.93,417.8,509.069,415.94z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M413.044,0.022h-33c-5.522,0-10,4.477-10,10s4.478,10,10,10h8.857l-116.86,116.861L195.568,60.41
			c-1.876-1.875-4.419-2.929-7.071-2.929c-2.652,0-5.195,1.054-7.071,2.929l-71.258,71.258c-3.905,3.906-3.905,10.237,0,14.143
			c3.906,3.906,10.236,3.905,14.143,0l64.187-64.188l76.473,76.473c1.953,1.953,4.512,2.929,7.071,2.929s5.118-0.976,7.071-2.929
			L403.044,34.165v8.857c0,5.523,4.478,10,10,10c5.522,0,10-4.477,10-10v-33C423.044,4.499,418.566,0.022,413.044,0.022z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M99.069,156.911c-1.859-1.86-4.439-2.93-7.069-2.93s-5.21,1.07-7.07,2.93s-2.93,4.44-2.93,7.07s1.069,5.21,2.93,7.07
			c1.861,1.86,4.44,2.93,7.07,2.93s5.21-1.07,7.069-2.93c1.86-1.86,2.931-4.44,2.931-7.07
			C102,161.341,100.93,158.771,99.069,156.911z"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#333'
    },
    width: {
      type: String,
      default: '24'
    },
    height: {
      type: String,
      default: '24'
    }
  }
}
</script>
